import React, { lazy, Suspense, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import LocationGuard from './components/LocationGuard/LocationGuard';
import LocationModal from './components/LocationModal/LocationModal';
import FloatingActionButtons from './components/FloatingActionButtons/FloatingActionButtons';
import AuthModal from './organism/LoginAuth/LoginModal';
import useAuthModalEvent from './hooks/useAuthModalEvent';
import './App.css';

const Dashboard = lazy(() => import('./pages/Dashboard/dashboard'));
const AdminDashboard = lazy(() => import('./pages/Admin/AdminDashboard'));
const Products = lazy(() => import('./pages/Products/Products'));
const Refrigerator = lazy(() => import('./pages/Refrigerator/Refrigerator'));
const ProductDetail = lazy(() => import('./pages/ProductDetail/ProductDetail'));
const Cart = lazy(() => import('./pages/Cart/Cart'));
const Checkout = lazy(() => import('./pages/Checkout/Checkout'));
const MoverService = lazy(() => import('./pages/Mover/MoverService'));
const RepairService = lazy(() => import('./pages/Repair/RepairService'));
const UserOrders = lazy(() => import('./pages/User/UserOrders'));
const Wishlist = lazy(() => import('./pages/Wishlist/Wishlist'));

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div style={{ textAlign: 'center' }}>
      <div className="spinner" style={{ width: '50px', height: '50px', border: '4px solid #f3f3f3', borderTop: '4px solid #418C95', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
      <p style={{ marginTop: '20px', color: '#666' }}>Loading...</p>
    </div>
  </div>
);

function App() {
  const [openGlobalAuth, setOpenGlobalAuth] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(true);
  useAuthModalEvent(() => setOpenGlobalAuth(true));

  return (
    <Provider store={store}>
      <Router>
        <LocationGuard>
          <div className="App">
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:category" element={<Refrigerator />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/my-orders" element={<UserOrders />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/mover" element={<MoverService />} />
                <Route path="/repair" element={<RepairService />} />
              </Routes>
            </Suspense>
            <FloatingActionButtons />
            <AuthModal open={openGlobalAuth} onClose={() => setOpenGlobalAuth(false)} />
            {showLocationModal && (
              <LocationModal onClose={() => setShowLocationModal(false)} />
            )}
          </div>
        </LocationGuard>
      </Router>
    </Provider>
  );
}

export default App;
